import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DatosBasicosComponent } from './datos-basicos/datos-basicos.component';
import { DatosUbicacionComponent } from './datos-ubicacion/datos-ubicacion.component';
import { DatosPadresComponent } from './datos-padres/datos-padres.component';
import { DatosAcudienteComponent } from './datos-acudiente/datos-acudiente.component';
import { ReactiveFormsModule } from '@angular/forms';
import { GLMMaterialDesignModule } from 'src/app/_components/material-design/material-design.module';
import { ActualizacionStepperComponent } from './actualizacion-stepper/actualizacion-stepper.component';
import { PersonaCardModule } from '../persona-card/persona-card.module';
import { ActualizacionDatosRoutingModule } from './glm-actualizacion-datos-routing.module';
import { CustomAlertModule } from 'src/app/_components/custom-alert/custom-alert.module';
import { ActualizacionStepComponent } from './actualizacion-step/actualizacion-step.component';

@NgModule({
  declarations: [
    DatosBasicosComponent,
    DatosUbicacionComponent,
    DatosPadresComponent,
    DatosAcudienteComponent,
    ActualizacionStepperComponent,
    ActualizacionStepComponent
  ],
imports: [
    CommonModule,
    ReactiveFormsModule,
    GLMMaterialDesignModule,
    PersonaCardModule,
    CustomAlertModule,
    
    ActualizacionDatosRoutingModule,
  ],
  exports: [
    DatosBasicosComponent, 
    DatosUbicacionComponent, 
    DatosPadresComponent, 
    DatosAcudienteComponent, 
    ActualizacionStepperComponent, 
    ActualizacionStepComponent
  ],
})
export class GlmActualizacionDatosModule { }
